<style scoped>
#subheader {
  height: 40%;
  /* height: 500px; */
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  z-index: -1;
}

#subheader img {
  width: 100%;
  height: auto;
  position: absolute;
}

#category-cards {
  background-color: rgb(35, 35, 35);
  padding-top: 4em;
  padding-bottom: 4em;
}

.image-card-wrapper {
  transition: all 0.5s;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-bottom: 100%;
  overflow: hidden;
}

.image-card-wrapper:focus .banner,
.image-card-wrapper:hover .banner {
  transform: scale(1.2);
}

.image-card-overlay {
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  transition: all 0.5s;
}

.image-card-wrapper:focus .image-card-overlay,
.image-card-wrapper:hover .image-card-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}

.image-card-caption {
  position: absolute;
  z-index: 2;
  color: #fff;
  font-size: 2em;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-card-caption .title {
  font-size: 0.5em;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 300;
  line-height: 1em;
  vertical-align: middle;
}

.image-card {
  padding: 2px;
}

.banner {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.section-title {
  margin-top: 48px;
  margin-bottom: 18px;
}

.title.small {
  font-weight: 300;
  font-size: 1.5em;
  letter-spacing: 0;
}

.card.tiny {
  height: 200px;
  position: relative;
}

#suppliers .card.horizontal .card-image {
  max-width: 40%;
}

#suppliers .card.horizontal .card-image img {
  position: relative;
  height: 100%;
  width: 100%;
}

.newscontainer {
  height: 260px;
  background-color: #333333;
}

.subscribe-title {
  margin: 0;
}
#email {
  width: 70%;
  margin-right: 40px;
}
.forms-builder-wrapper {
  max-width: 840px !important;
}
/* #subheader img {
  position: absolute;
  top: 0;
  right: 0;
  max-height: 300px;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  -webkit-transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}*/
/* <button v-on:click="alertDisplay">Click Me!</button> */
</style>
<template lang="pug">
    div
      slot(ref='subheader' name='billboard' :content='billboard')
      // div.newscontainer(v-if='!user')
      //   iframe(width='100%', height='250', src='https://my.sendinblue.com/users/subscribe/js_id/3kiuj/id/1',
      //   frameborder='0', style='display: block;')
      //- nletter



</template>
<script>
/* eslint-disable no-undef */
import AppDeliveryBar from '@/components/app-delivery-bar'
import AppSmallBox from '@/components/app-small-box'
import PageHomeBillboard from '@/components/page-home-billboard'
import nletter from '@/components/app-newletter-invites'

// import viewmodal from '@/components/modal'

export default {
  meta: {
    title: 'Spirits & Liquor Direct'
  },
  data () {
    return {
      billboard: PageHomeBillboard,
      fixDeliveryBar: false,
      suppliers: null,
      step: 1,
      registration: {
        Fname: null,
        Lname: null,
        contact: null,
        email: null,
        password: null,
        vpassword: null,
        storeName: null,
        storeAddress: null,
        storeTelNo: null,
        businessName: null,
        MainOfficeAddress: null,
        businessTel: null,
        typeOforg: null,
        natureOfBusiness: null,
        TINNo: null,
        yearsOfOperation: null,
        SECRegNo: null,
        street: null,
        city: null,
        state: null,
        numtickets: 0,
        shirtsize: 'XL'
      }
    }
  },
  destroyed () {
    clearInterval(this.bgChange)
  },
  computed: {
    deliveryAddress () {
      return this.$store.state.customer.deliveryAddress
    },
    background () {
      return require('../assets/avatar-background.png')
    },
    user () {
      return this.$store.state.auth.user
    }
  },
  components: {
    AppDeliveryBar,
    AppSmallBox,
    nletter
  },
  methods: {
    alertDisplay () {
      this.$swal({
        html:
          '<iframe width="100%" height="249" src="https://my.sendinblue.com/users/subscribe/js_id/3kiuj/id/2" frameborder="0" scrolling="auto" allowfullscreen style="display: block;margin-left: auto;margin-right: auto;"></iframe>',
        showCloseButton: true,
        showConfirmButton: false
        // showCancelButton: true,
        // focusConfirm: false
      })
    },
    prev () {
      this.step--
    },
    next () {
      this.step++
    },
    submit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-home.vue